class GaLoader {

	constructor() {
		this.load();
	}

	load() {
		if (window.konfig.gaKey && !this.isLoaded()) {
			(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
			(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
			m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
			})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

			ga('create', window.konfig.gaKey, 'auto');
		}
	}

	isLoaded() {
		return (typeof window.ga === 'function');
	}
}

const GALoader = new GaLoader();
export default function gaPush(type = 'view', category = '', name = '') {
	GALoader.load();

	if (GALoader.isLoaded()) {
		if (type === 'event') {
			return window.ga('send', {
				hitType: 'event',
				eventCategory: category,
				eventAction: 'click',
				eventLabel: name,
			});
		} else if (type === 'view') {
			// console.log('pageView');
			// console.log(window.location.pathname);

			return window.ga('send', {
				hitType: 'pageview',
				page: window.location.pathname,
			});
		}
	} else {
		console.log('it ain\'t loaded BRO');
	}

	return false;
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/gaTrack.js
 **/